var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13037 1.71875L12.1929 10.3438C12.3569 10.6484 12.3569 11 12.1929 11.2812C12.0288 11.5859 11.7241 11.75 11.396 11.75H1.271C0.919434 11.75 0.614746 11.5859 0.450684 11.2812C0.286621 11 0.286621 10.6484 0.450684 10.3438L5.51318 1.71875C5.67725 1.4375 5.98193 1.25 6.3335 1.25C6.66162 1.25 6.96631 1.4375 7.13037 1.71875Z",
    fill: "#B3D67B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenUpArrow);
export default __webpack_public_path__ + "static/media/green_up_arrow.c6b58e4ab9cdc61dd5226bf5fc721f2f.svg";
export { ForwardRef as ReactComponent };